import { render, staticRenderFns } from "./FilesUploader.vue?vue&type=template&id=caae3fb6&"
import script from "./FilesUploader.vue?vue&type=script&lang=js&"
export * from "./FilesUploader.vue?vue&type=script&lang=js&"
import style0 from "./FilesUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports